import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import LogisticQuoteComponent from '../components/logistics-quote.component';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectQuotesQueryItems } from '../../../../../../redux/quotes/selector';
import { quotes } from '../../../../../../redux/quotes/action';
import PageLoader from '../../../../../../components/PageLoader';


const CustomerQuote = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const quoteQuery = useSelector(selectQuotesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    quoteDetails,
    setQuoteDetails
  ] = useState<any>([])

  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'CategoryName', headerName: 'Category Name' },
      { field: 'SubCategoryName', headerName: 'Sub Category Name' },
      { field: 'ProductTypeName', headerName: 'Product Type Name' },
      { field: 'VehicleBrand', headerName: 'Vehicle Brand' },
      { field: 'VehicleChassisNumber', headerName: 'Vehicle Chassis Number' },
      { field: 'VehicleModel', headerName: 'Vehicle Model' },
      { field: 'VehicleNumber', headerName: 'Vehicle Number' },
      { field: 'VehicleYear', headerName: 'Vehicle Year' }

    ]);
  };

  const fetchVehicleById = () => {
    dispatch(quotes.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/quotes/fetch-detail`, entity: 'quotes', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }

        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }


  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split('.', field);
    const value = { ...data, [fields[0]]: event }; // inner data update
    setQuoteDetails({ ...quoteDetails, [fields[0]]: value });
  };
  useEffect(
    () => {
      if (parmas?.id > 0) {
        createColumnDefs()
        fetchVehicleById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setQuoteDetails(quoteQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const back = () => {
    navigate('/customer/sales/quotes')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <LogisticQuoteComponent
          handleInnerFormChange={handleInnerFormChange}
          quoteDetails={quoteDetails}
          rowData={quoteDetails?.MobilityQuoteItems}
          columnDefs={columnDefs}
          back={back}
        />}
    </>
  )

}

export default CustomerQuote;